module.exports = __webpack_public_path__ + "9976467778a2e0d148a63f022d3e5c75.svg";